<template>
  <a @click="handleClick()" :class="a_class">
    <i class="far fa-trash-alt" v-if="isExcluded === false"></i>
    <i class="fas fa-trash-alt"  v-if="isExcluded === true"></i>
  </a>
</template>

<script>
export default {
  props: ['id', 'a_class'],
  // data () {return {
  //
  // }},
  computed: {
    isExcluded () {
      return _.includes(this.$root.excluded_list, this.id)
    },
    isFavourite () {
      return _.includes(this.$root.user.preferiti, this.id)
    }
  },
  methods: {
    /**
     * Gestisco tramite questa funzione i se devo aggiungere o rimuovere l'elemento
     */
    handleClick () {
      if (!this.isFavourite) {

          if (this.$root.user.id && !window.axios.defaults.headers.common['UserAuthorization']) {
              this.postHeaders = {
                  'userauthorization': 'Bearer ' + this.$root.userToken,
              }
          }

        if (this.isExcluded === true) {
          this.unsetExcluded()

        }
        if (this.isExcluded === false) {
          this.setExcluded()
        }

      } else {
        Swal.fire({
          // title: 'Complimenti!',
          text: "Non si puo escludere un elemento salvato nei preferiti",
          type: 'info'
        });
      }
    },
    unsetExcluded () {
      window.axios
          .delete(window.base_url + 'immobili/exclude/' + this.id, {
              headers:this.postHeaders
          })
          .then( res => {
            // Nel caso di risposta positiva sparo un toast
            Swal.fire({
              // title: 'Complimenti!',
              text: res.data.data.message,
              type: 'success'
            });
            this.impostoEsclusi(res.data.data.esclusi)
            // setto preferiti nel utente
          })
          .catch(error => {

            // Stoppo il loading
            this.$root.stopLoading();

            // Se la risposta dal server è un non autorizzato apro la modale di login..
            // altrimenti si è rotto Pietro
            switch (error.response.status) {
              case 401:
                this.$root.showLogin();
                break;
              case 422:
                Swal.fire({
                  title: 'Attenzione!',
                  text: 'Hai raggiunto il limite massimo di ricerche salvabili',
                  type: 'info'
                });
                break;
              default:
                Swal.fire({
                  title: 'Ooops!',
                  text: 'Problemi nel caricamento dati',
                  type: 'error'
                });
                break;
            }
          });
    },
    setExcluded () {
      window.axios
          .post(window.base_url + 'immobili/exclude/' + this.id, [], {
              headers:this.postHeaders
          })
          .then( res => {
            // Nel caso di risposta positiva sparo un toast
            Swal.fire({
              // title: 'Complimenti!',
              text: res.data.data.message,
              type: 'success'
            });
            this.impostoEsclusi(res.data.data.esclusi)
            // setto preferiti nel utente
          })
          .catch(error => {
                  // Stoppo il loading
            this.$root.stopLoading();

            // Se la risposta dal server è un non autorizzato apro la modale di login..
            // altrimenti si è rotto Pietro
            switch (error.response.status) {
              case 401:
                this.$root.showLogin();
                break;
              case 422:
                Swal.fire({
                  title: 'Attenzione!',
                  text: 'Hai raggiunto il limite massimo di ricerche salvabili',
                  type: 'info'
                });
                break;
              default:
                Swal.fire({
                  title: 'Ooops!',
                  text: 'Problemi nel caricamento dati',
                  type: 'error'
                });
                break;
            }
                });
    },
    impostoEsclusi (excluded_list) {
      this.$root.setExcluded(excluded_list)

    }
  },
  mounted() {

  },
    data(){
        return{
            postHeaders: {},
        }
    }
}
</script>
